"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBackButton = exports.StyledErrorBanner = exports.StyledCancelPageHeader = exports.ButtonContainer = exports.StyledSelect = exports.CancelContentContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const banner_1 = __importDefault(require("@kyruus/banner"));
const simple_select_1 = require("@kyruus/simple-select");
const ui_theme_1 = require("@kyruus/ui-theme");
const button_1 = require("@kyruus/button");
exports.CancelContentContainer = (0, styled_1.default)('div') `
  display: flex;
  flex-direction: column;
  width: 100%;
`;
exports.StyledSelect = (0, styled_1.default)(simple_select_1.SingleSelect) `
  max-width: ${({ isDesktop }) => (isDesktop ? '28rem' : '100%')};
  margin-bottom: ${(_a) => {
    var { isDesktop } = _a, rest = __rest(_a, ["isDesktop"]);
    return isDesktop
        ? (0, ui_theme_1.fromTheme)('spacing_xxlarge')(rest)
        : (0, ui_theme_1.fromTheme)('spacing_xlarge')(rest);
}};
  label {
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
    padding: 0;
    padding-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    // overriding default styles
    text-indent: 0;
    font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  }
  select {
    padding: ${(0, ui_theme_1.fromTheme)('spacing_small')} ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }
`;
exports.ButtonContainer = (0, styled_1.default)('div') `
  display: flex;
  justify-content: start;
  width: ${({ isDesktop }) => (isDesktop ? 'auto' : '100%')};
  button {
    width: ${({ isDesktop }) => (isDesktop ? 'auto' : '100%')};
    padding: ${(0, ui_theme_1.fromTheme)('spacing_small')} ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }
`;
exports.StyledCancelPageHeader = styled_1.default.div `
  margin: 0;
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
`;
exports.StyledErrorBanner = (0, styled_1.default)(banner_1.default) `
  margin-bottom: ${({ isDesktop }) => isDesktop ? (0, ui_theme_1.fromTheme)('spacing_xlarge') : (0, ui_theme_1.fromTheme)('spacing_large')};
`;
exports.StyledBackButton = (0, styled_1.default)(button_1.ButtonLinkWithIcon) `
  display: flex;
  width: fit-content;
  padding-left: 0;
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')};
`;
//# sourceMappingURL=styles.js.map